import * as Yup from 'yup';
import { FormErrorMessages } from 'utils/formValidation';

export const CreatePartnerCategorySchema = () =>
    Yup.object().shape({
        label: Yup.string()
            .min(3, FormErrorMessages.min_characters)
            .max(50, FormErrorMessages.max_characters)
            .required(FormErrorMessages.required)
    });
